export default __webpack_public_path__ + "static/media/imagem_01.391cb416.png";